import React from 'react';

interface UserReportsIconProps {
    isActive?: boolean;
}

const UserReportsIcon: React.FC<UserReportsIconProps> = ({ isActive = false }) => {

    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect
                x="1.5"
                y="8.5"
                width="3"
                height="6"
                rx="1"
                stroke="currentColor"
                fill={isActive ? 'currentColor' : 'none'}
            />
            <rect
                x="6.5"
                y="4.5"
                width="3"
                height="10"
                rx="1"
                stroke="currentColor"
                fill={isActive ? 'currentColor' : 'none'}
            />
            <rect
                x="11.5"
                y="1.5"
                width="3"
                height="13"
                rx="1"
                stroke="currentColor"
                fill={isActive ? 'currentColor' : 'none'}
            />
        </svg>
    );
};

export default UserReportsIcon;
